// @flow

import _ from "lodash";

import type { UserTask } from "../data/user-results";

function betaVariance(alpha: number, beta: number): number {
  return alpha * beta / (Math.pow(alpha + beta, 2) * (alpha + beta + 1));
}

function betaMean(alpha: number, beta: number): number {
  return alpha / (alpha + beta);
}

function coarsen(confidence: number): number {
  return Math.floor(confidence / 10) * 10;
}

export type CalibrationStats = Array<{
  confidence: number,
  mean: number,
  stdev: number
}>;

export function stats(
  tasks: Array<UserTask>,
  resultIndex: number
): CalibrationStats {
  // 1. Compute how often answer was true for each of the confidences
  const confidences = _.range(21)
    .map(x => x * 5)
    .map(coarsen);
  // Initialize Beta with pseudo-counts (Laplace smoothing)
  const counts = _.fromPairs(confidences.map(x => [x, { false: 1, true: 1 }]));
  tasks.forEach(task => {
    const result = task.results[resultIndex];
    if (result && result.kind === "response") {
      const confidence = coarsen(result.confidence);
      if (task.answer) {
        counts[confidence].true += 1;
      } else {
        counts[confidence].false += 1;
      }
    }
  });

  // 2. Compute posterior means and standard deviation for Beta-Binomial distribution
  const stats = _.sortBy(
    _.map(counts, (x, i) => {
      const confidence = parseInt(i, 10);
      return {
        confidence,
        mean: betaMean(x.true, x.false) * 100,
        stdev: Math.sqrt(betaVariance(x.true, x.false)) * 100
      };
    }),
    "confidence"
  );

  return stats;
}



// WEBPACK FOOTER //
// ./src/utils/calibration.js